import React from "react";
import { Dropdown } from "../../common/components/dropdownSelect";
import { formGroup } from "../../common/components/formGroup";
import { TipoFGas } from "../../generated";
const DropdownList = Dropdown<TipoFGas>();

export const TipoFgasType = [
    TipoFGas.CellaAutocarro,
    TipoFGas.CommutatoreElettrico,
    TipoFGas.Condizionamento,
    TipoFGas.PompaCalore,
    TipoFGas.ProtezioneAntincendio,
    TipoFGas.Refrigerazione,
];

export function GetFGasDescription(type: TipoFGas) {
    switch (type) {
        case TipoFGas.CellaAutocarro:
            return "Cella frigorifero di autocarro o rimorchio frigorifero";
        case TipoFGas.CommutatoreElettrico:
            return "Commutatore Elettrico";
        case TipoFGas.Condizionamento:
            return "Apparecchiatura fissa di condizionamento d'aria";
        case TipoFGas.PompaCalore:
            return "Pompa di calore fissa";
        case TipoFGas.ProtezioneAntincendio:
            return "Apparecchiatura di protezione anticendio";
        case TipoFGas.Refrigerazione:
            return "Apparecchiatura fissa di refrigerazione";
        default:
            return "";
    }
}

interface Props {
    value: TipoFGas | null,
    onChange: (type: TipoFGas | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
class __TipoFGasSelector extends React.PureComponent<Props> {

    render() {
        const { onChange, value, error, label, onBlur, onFocus } = this.props;
        return <DropdownList
            label={label}
            allowNull
            data={TipoFgasType}
            textField={x => GetFGasDescription(x)}
            onSelect={onChange}
            value={value}
            error={error}
            onBlur={onBlur}
            onFocus={onFocus}
        />;
    }
}
export default formGroup(__TipoFGasSelector)

